/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Asset, AssetOption, Channel, Ducks, DisabledFeaturesValues, EntryPoint } from '@wit/vtv-x-foundation-lib';
import { SagaIterator } from 'redux-saga';
import { call, select } from 'redux-saga/effects';
import Options from 'core/store/ducks/pi/options';
import { Selectors as ChannelSelectors } from 'core/store/ducks/epg/channels';
import { SeasonsData } from '../../../../core/store/ducks/pi/seasons';

export default function* getRecordingOptions(
  entryPoint: EntryPoint | undefined,
  asset: Asset,
  clones: Asset[],
  seasons?: SeasonsData
): SagaIterator<AssetOption[]> {
  try {
    const isRecordingsDisabled = yield select(Ducks.Dms.Selectors.isFeatureDisabled, DisabledFeaturesValues.NO_PVR);

    if (!isRecordingsDisabled) {
      const channels: Channel[] = yield select(ChannelSelectors.getChannels);
      return yield call(Options.getRecordingsOptions, entryPoint, asset, clones, channels, seasons);
    }
    return [];
  } catch {
    return [];
  }
}
